import axios from 'axios';
import { API_BASE_URL } from '../../config/apiConfig';

const base = API_BASE_URL;

const handle = (err, fallback) => {
    if (err.response?.data) throw err.response.data;
    throw err.message || fallback;
};

// "Select All" (with a space) is the literal the backend data layer / spGetClientInvoice compare against.

export const getCIRClients = async () => {
    try {
        const res = await axios.get(`${base}/Reports/GetAllclients`);
        return res.data;
    } catch (err) { return handle(err, 'Failed to fetch clients'); }
};

export const getCIRSubClients = async (clientcode) => {
    try {
        const res = await axios.get(`${base}/Reports/GetSubClientsbyClientID`, { params: { clientcode } });
        return res.data;
    } catch (err) { return handle(err, 'Failed to fetch sub-clients'); }
};

export const getCIRCCs = async (Client, SubClient, CCStatusval) => {
    try {
        const res = await axios.get(`${base}/Reports/GetCCbyClient`, { params: { Client, SubClient, CCStatusval } });
        return res.data;
    } catch (err) { return handle(err, 'Failed to fetch cost centres'); }
};

export const getCIRPOs = async (Client, SubClient, CCCode) => {
    try {
        const res = await axios.get(`${base}/Reports/GetPobyCCAndClient`, { params: { Client, SubClient, CCCode } });
        return res.data;
    } catch (err) { return handle(err, 'Failed to fetch PO numbers'); }
};

// One line per invoice with notes, receipts and receivable (spGetClientInvoiceReceivable). Legacy's
// GetClientInvoiceData returned one row per bank receipt and is left for the legacy page.
// All 8 params must be present for Web API to match the action (From/To may be empty strings).
export const getCIRReport = async ({ Client, SubClient, From, To, CCCode, PO, Type, CCStatusval }) => {
    try {
        const res = await axios.get(`${base}/Reports/GetClientInvoiceReceivable`, {
            params: { Client, SubClient, From: From || '', To: To || '', CCCode, PO, Type, CCStatusval },
        });
        return res.data;
    } catch (err) { return handle(err, 'Failed to fetch client invoice report'); }
};

// MOID 488 = trading invoice, 562 = manufacturing invoice (same split as legacy)
export const getCIRInvoiceItems = async (Invoiceno, Pono, moid) => {
    try {
        const route = moid === '488' ? 'ViewClientTradeInvoiceItems' : 'ViewClientManufactureInvoiceItems';
        const res = await axios.get(`${base}/Reports/${route}`, { params: { Invoiceno, Pono } });
        return res.data;
    } catch (err) { return handle(err, 'Failed to fetch invoice items'); }
};
